import { computed, ref, markRaw } from 'vue'
import { defineStore } from 'pinia'
import { createUserAuthClient } from '@/service/auth-client.mjs'

export const useAuthStore = defineStore('user-auth', () => {
  const member = ref(null), endingSession = ref(false)
  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('techedu-user-session') : null
  // Nuxt payload·Pinia state에 access를 넣지 않는다. 클라이언트 클로저만 비밀값을 소유한다.
  const client = markRaw(createUserAuthClient({ onSession: value => { member.value = value }, notify: () => channel?.postMessage('reset') }))
  if (channel) channel.onmessage = event => { if (event.data === 'reset') client.clear(false) }
  const isLoggedIn = computed(() => Boolean(member.value)), isManager = computed(() => member.value?.roles.includes('TRAINING_MANAGER') === true)
  async function identify() {
    const value = await client.request('/api/user/auth/me')
    if (typeof value?.memberKey !== 'string' || !Array.isArray(value.roles)) throw new Error('계정 응답을 확인할 수 없습니다.')
    member.value = { memberKey: value.memberKey, roles: [...value.roles] }; return member.value
  }
  return { member, isLoggedIn, isManager, endingSession, client, identify }
})
